import { render, staticRenderFns } from "./TheProfile.vue?vue&type=template&id=140f0cd6&"
import script from "./TheProfile.vue?vue&type=script&lang=js&"
export * from "./TheProfile.vue?vue&type=script&lang=js&"
import style0 from "./TheProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports